import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./page-heading.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./page-heading.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { RouterParamsService } from "../../services/route-params.service";
import { UserInformationService } from "../../services/user/user-information.service";
import { filter, take, takeUntil } from "rxjs/operators";
import { UcFirstPipe } from "ngx-pipes";
import { Subject } from "rxjs";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { ActivatedRoute, Router } from "@angular/router";
import { ViewApplicationRoutingConstants } from "../../../application/view-application/view-application-routing.constants";
import { SharedConstants } from "../../constants/shared.constants";
import { CurrentStepService } from "../../services/current-step/current-step.service";
import { ViewApplicationService } from "src/app/application/view-application/view-application.service";
import { AppControllerService } from "src/app/app-controller.service";
let PageHeadingComponent = class PageHeadingComponent {
    routerParamsService;
    viewApplicationService;
    currentStepService;
    userInformationService;
    changeDetectorRef;
    appController;
    router;
    ucFirst;
    route;
    viewApplicationText = SharedConstants.VIEW_APPLICATION_TEXT;
    _destroy$ = new Subject();
    _heading = "";
    standardCase = true;
    listenForRouteParamChangesSubscription;
    getAttachmentContentBase64Subscription;
    set heading(value) {
        if (this.standardCase) {
            this._heading = this.ucFirst.transform(value.toLowerCase());
        }
        else {
            this._heading = value;
        }
    }
    get heading() {
        return this._heading;
    }
    subheading;
    moduleHeading;
    organisationHeading;
    subscriptions = {};
    isNotMobileDevice = true;
    isNotSmallMobileDevice = true;
    currentModule;
    currentOrganisation;
    currentJobId;
    showGenerateReportButton = false;
    generateReportText = SharedConstants.GENERATE_REPORT_LABEL;
    constructor(routerParamsService, viewApplicationService, currentStepService, userInformationService, changeDetectorRef, appController, router, ucFirst, route) {
        this.routerParamsService = routerParamsService;
        this.viewApplicationService = viewApplicationService;
        this.currentStepService = currentStepService;
        this.userInformationService = userInformationService;
        this.changeDetectorRef = changeDetectorRef;
        this.appController = appController;
        this.router = router;
        this.ucFirst = ucFirst;
        this.route = route;
    }
    ngOnInit() {
        this.listenForRouteParamChanges();
        this.subscriptions["$isMobileDevice"] = this.appController.$isMobileDevice.subscribe(value => {
            this.isNotMobileDevice = !value;
            this.changeDetectorRef.detectChanges();
        });
        this.subscriptions["$isSmallMobileDevice"] = this.appController.$isSmallMobileDevice.subscribe(value => {
            this.isNotSmallMobileDevice = !value;
            this.changeDetectorRef.detectChanges();
        });
    }
    listenForRouteParamChanges() {
        const onlyValidParams = this.routerParamsService.params.pipe(filter(param => param.moduleid || param.organisationid));
        this.listenForRouteParamChangesSubscription = onlyValidParams.subscribe((params) => {
            if (params) {
                if (params.moduleid && this.router.url.includes("viewapplication")) {
                    this.currentJobId = params.jobID;
                    this.userInformationService.$systemModules.pipe(takeUntil(this._destroy$), take(1)).subscribe((modules) => {
                        if (modules !== undefined && modules !== null && modules.length > 0) {
                            this.currentModule = this.userInformationService.getModuleInformation(+params.moduleid);
                            if (this.currentModule.organisation?.name === "Mondi") {
                                this.showGenerateReportButton = true;
                            }
                            this.setModuleHeadings();
                        }
                    });
                }
                else if (params.organisationid) {
                    this.userInformationService.$systemOrganisations.pipe(takeUntil(this._destroy$), take(1)).subscribe((organisations) => {
                        if (organisations !== undefined && organisations !== null && organisations.length > 0) {
                            this.currentOrganisation = this.userInformationService.getOrganisationInformation(+params.organisationid);
                            this.setOrganisationPageHeadings();
                        }
                    });
                }
            }
        });
    }
    setModuleHeadings() {
        if (this.currentModule) {
            this.moduleHeading = this.currentModule.name;
            this.organisationHeading = this.currentModule.organisation?.name;
            this.changeDetectorRef.markForCheck();
        }
    }
    setOrganisationPageHeadings() {
        if (this.currentOrganisation) {
            this.organisationHeading = this.currentOrganisation.name;
            this.changeDetectorRef.markForCheck();
        }
    }
    navigateToApplicationDetails($event) {
        this.currentStepService.setLoadStep(false);
        this.router.navigate([ViewApplicationRoutingConstants.APPLICATION_CONTENT_ROUTE, { loadSteps: false }], { relativeTo: this.route.parent?.parent });
    }
    generateReport($event) {
        this.viewApplicationService.GetMNDAttachmentConsolidatedPDFReport(this.currentModule.id, this.currentJobId)
            .subscribe((response) => {
            const blobUrl = URL.createObjectURL(response);
            const newTab = window.open(blobUrl, '_blank');
        }, (error) => {
            console.error("Error generating report PDF: ", error);
        });
    }
    shouldShowViewApplicationLink() {
        return this.router.url.includes("viewapplication") && this.router.url.includes("step");
    }
    static ctorParameters = () => [
        { type: RouterParamsService },
        { type: ViewApplicationService },
        { type: CurrentStepService },
        { type: UserInformationService },
        { type: ChangeDetectorRef },
        { type: AppControllerService },
        { type: Router },
        { type: UcFirstPipe },
        { type: ActivatedRoute }
    ];
    static propDecorators = {
        standardCase: [{ type: Input }],
        heading: [{ type: Input }],
        subheading: [{ type: Input }]
    };
};
PageHeadingComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-page-heading[heading]",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], PageHeadingComponent);
export { PageHeadingComponent };
